<script setup lang="ts">
defineProps({
	color: {
		type: String,
		required: false,
		default: "#FFFFFF",
	},
});
</script>

<template>
	<svg width="38" height="38" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
		<path d="M11 11H7V7h4ZM17 7h-2v2h2ZM13 17h4v-4h-4ZM7 17h2v-2H7Z" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
		<path d="M8 3H4a1 1 0 0 0-1 1V8" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
		<path d="M21 8V4a1 1 0 0 0-1-1H16" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
		<path d="M3 16v4a1 1 0 0 0 1 1H8" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
		<path d="M16 21h4a1 1 0 0 0 1-1V16" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
	</svg>
</template>
